import React from 'react';
import TeamMemberCard from '../TeamMemberCard';
import WatercolorWash from '../WatercolorWash';
import { useReveal } from '../../hooks/useReveal';
import { GOVERNANCE_BODIES, teamByBody } from '../../data/team';
import '../../styles/Team.css';

const Team: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`team psl-reveal${revealed ? ' is-in-view' : ''}`}
    >
      <WatercolorWash
        variant="b"
        color="#7a8b5f"
        opacity={0.18}
        style={{ top: '60px', right: '-120px' }}
      />

      <div className="team__header">
        <div className="team__chapter">— quem decide, na PSL</div>
        <h2 className="team__head">
          Os <em>órgãos sociais</em> — empossados em 2025.
        </h2>
        <p className="team__intro">
          A associação é dirigida por três corpos eleitos pelos sócios. Aqui estão,
          pelo nome.
        </p>
      </div>

      {GOVERNANCE_BODIES.map((body) => {
        const members = teamByBody(body.id);
        return (
          <div className="team__body" key={body.id}>
            <div className="team__body-head">
              <h3 className="team__body-label">{body.label}</h3>
              <p className="team__body-note">{body.note}</p>
            </div>
            <div className="team__grid">
              {members.map((m) => (
                <TeamMemberCard
                  key={m.id}
                  member={m}
                  tapeColor={body.tapeColor}
                />
              ))}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Team;
